<template>
  <section v-if="generalNav">
    <div v-for="(navItem, index) in navLink" :key="index" class="">
      <!-- no dropdown -->
      <section v-if="generalNav(navItem)">
        <NoDropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>
      <!-- dropdown -->
      <section v-if="generalNav(navItem)">
        <DropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>
      <!--  -->
    </div>
  </section>
</template>

<script>
//components

import NavText from "../Text/NavText.vue";
import DropdownNav from "@/components/UI/AutomatedSidebar/DropdownNav.vue";
import NoDropdownNav from "@/components/UI/AutomatedSidebar/NoDropdownNav.vue";

export default {
  name: "GeneralNav",
  props: ["navLink", "getNavIcon", "modules"],

  components: {
    NavText,
    DropdownNav,
    NoDropdownNav,
  },
  methods: {
    //utilities
    generalNav(navItems) {
      const nav = navItems?.name?.toLowerCase();

      // if (
      //   (nav === "depot" && this.modules?.includes("dealers")) ||
      //   (nav === "depot" && this.modules?.includes("depot")) ||
      //   (nav === "program" && this.modules?.includes("program")) ||
      //   (nav === "concession" && this.modules?.includes("concession")) ||
      //   (nav === "dealer" && this.modules?.includes("dealer")) ||
      //   // customer navs
      //   (nav === "card management" &&
      //     this.modules?.includes("card management")) ||
      //   (nav === "dry stock order" &&
      //     this.modules?.includes("dry stock order")) ||
      //   //other navs
      //   (nav === "teams" && this.modules?.includes("teams")) ||
      //   (nav === "support" && this.modules?.includes("support")) ||
      //   (nav === "settings & control" &&
      //     this.modules?.includes("settings & control"))
      // ) {
      //   return false;
      // }
      // return true;

      if (
        (nav === "tank viewer" && (this.modules?.includes("tank viewer") && !this.modules?.includes("tank manager"))) ||
        (nav === "tank manager" && this.modules?.includes("tank manager")) ||
        // (nav === "tanks" && this.modules?.includes("tanks")) ||
        (nav === "payment inflow" &&
          this.modules?.includes("payment inflow")) ||
        (nav === "refund request" &&
          this.modules?.includes("refund request")) ||
        (nav === "inventory" && this.modules?.includes("inventory")) ||
        (nav === "users" && this.modules?.includes("users"))
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
